import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'desktop-isf-summary-card',
  template: `
    <div class="card-summary">
      <div class="card-summary-header">
        <h3>{{ header }}</h3>
      </div>

      <div class="card-summary-body" [ngClass]="{ 'is-column': isColumn }"><ng-content select="[body]"></ng-content></div>

      <div class="card-summary-footer"><ng-content select="[footer]"></ng-content></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./desktop-summary-card.component.scss'],
})
export class DesktopSummaryCardComponent {
  @Input() public header: string;
  @Input() public isColumn: boolean;

  constructor() {}
}
